import {
  GridColumnMenuCheckboxFilter,
  GridColumnMenuFilter,
  GridColumnMenuSort,
} from "@progress/kendo-react-grid";
import './widget-grid-filter.scss';
import PropTypes from "prop-types";

export function isFilteredColumn(fieldName, filterDescriptor) {
  if (!filterDescriptor || !fieldName) {
    return false;
  }

  const recurse = (desc) => {
    if (!desc.filters) {
      return false;
    }
    return desc.filters.some((f) => {
      if (f.field === fieldName) {
        return true;
      }
      if (f.logic && f.filters) {
        return recurse(f);
      }
      return false;
    });
  };

  return recurse(filterDescriptor);
}

const WidgetGridFilter = ({ props, gridData, disabled = false }) => {
  const field = (props.column?.field || "").toLowerCase();
  const isDateField = field.includes("date") || field.includes("updated");

  if (disabled) {
    return (
      <div className="disabled-filter-message">
        Filtering is not available for this column within an active Search
      </div>
    );
  }
   if (field === "members") {
    const memberSet = new Set();

    gridData.forEach((item) =>
      (item.MemberNamesArray || []).forEach((name) => {
        if (name) memberSet.add(name);
      })
    );

    const memberOptions = Array.from(memberSet).map((name) => ({ Members: name }));

    return (
      <>
        <GridColumnMenuCheckboxFilter
          {...props}
          data={memberOptions}
          expanded={true}
        />
        <GridColumnMenuSort {...props} />
      </>
    );
  }
  if (field === "seniormembers") {
    const seniorSet = new Set();

    gridData.forEach((item) =>
      (item.SeniorMemberNamesArray || []).forEach((name) => {
        if (name) seniorSet.add(name);
      })
    );

    const seniorOptions = Array.from(seniorSet).map((name) => ({ SeniorMembers: name }));

    return (
      <>
        <GridColumnMenuCheckboxFilter
          {...props}
          data={seniorOptions}
          expanded={true}
        />
        <GridColumnMenuSort {...props} />
      </>
    );
  }
  if (field === "dealteam") {
    const memberSet = new Set();
    gridData.forEach((item) =>
      (item.DealTeamNamesArray || []).forEach((name) => {
        if (name) memberSet.add(name);
      })
    );

    const memberOptions = Array.from(memberSet).map((name) => ({ DealTeam: name }));

    return (
      <>
        <GridColumnMenuCheckboxFilter
          {...props}
          data={memberOptions}
          expanded={true}
        />
        <GridColumnMenuSort {...props} />
      </>
    );
  }
  if (field === "staffers") {
    const memberSet = new Set();

    gridData.forEach((item) =>
      (item.StafferNamesArray || []).forEach((name) => {
        if (name) memberSet.add(name);
      })
    );

    const memberOptions = Array.from(memberSet).map((name) => ({ Staffers: name }));

    return (
      <>
        <GridColumnMenuCheckboxFilter
          {...props}
          data={memberOptions}
          expanded={true}
        />
        <GridColumnMenuSort {...props} />
      </>
    );
  }
  const filteredOptions = gridData.filter((item) => {
    const value = item[props.column.field];
    return value !== null && value !== undefined;
  });

  return (
    <>
      {isDateField ? (
        <GridColumnMenuFilter {...props} expanded={true} />
      ) : (
        <GridColumnMenuCheckboxFilter
          {...props}
          data={filteredOptions}
          expanded={true}
        />
      )}
      <GridColumnMenuSort {...props} />
    </>
  );
};

WidgetGridFilter.propTypes = {
  props: PropTypes.shape({
    column: PropTypes.shape({
      field: PropTypes.string,
    }),
    filter: PropTypes.object,
  }).isRequired,
  gridData: PropTypes.array.isRequired,
  disabled: PropTypes.bool,
};

export default WidgetGridFilter;
